export default __webpack_public_path__ + "static/media/flag.348322a7.png";